/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery, useQueryClient } from 'react-query';
import {
  closeTerminal,
  getTerminals,
  updateTerminal,
  createTerminal,
  getAllTerminals,
  getApiKeyInfo,
  getTerminalsById,
} from '~/api/terminals';

import { Terminal } from '~/types/index';
import { terminals } from '~/routes';
import {
  useDeleteMutation,
  useEditMutation,
  usePageQuery,
  useCreateMutation,
} from './usePageQuery';

export const useTerminalsQuery = (options?: any) => {
  return usePageQuery<Terminal[]>(terminals, getTerminals, options);
};

export const useTerminalsEdit = (closeParent?: () => void) => {
  const queryClient = useQueryClient();
  return useEditMutation(terminals, updateTerminal, {
    onMutate: closeParent,
    onSuccess() {
      void queryClient.invalidateQueries(terminals);
    },
  });
};

export const useTerminalsCreate = (closeParent: () => void) => {
  const queryClient = useQueryClient();
  return useCreateMutation(terminals, (body: Terminal) => createTerminal(body), {
    onMutate: closeParent,
    onSuccess() {
      void queryClient.invalidateQueries(terminals);
    },
  });
};

export const useTerminalsDelete = (closeParent: () => void) => {
  const queryClient = useQueryClient();
  return useDeleteMutation(terminals, closeTerminal, {
    onMutate: closeParent,
    onSuccess() {
      void queryClient.invalidateQueries(terminals);
    },
  });
};

export const useAllTerminals = () => {
  return useQuery<Terminal[]>(terminals, () => getAllTerminals().then((res) => res.data), {
    staleTime: 60 * 1000,
  });
};

export const useTerminalsById = (terminalId?: string) => {
  return useQuery(['terminal', terminalId], () => getTerminalsById(terminalId!), {
    enabled: !!terminalId,
  });
};

export const useGetApiKeyInfo = (terminalId: string) => {
  return useQuery(['apiKeyInfo', terminalId], () => getApiKeyInfo(terminalId));
};
